import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchQuizzes, quizDeleted } from '../../redux/quizzesSlice';
import AdminNavMain from './AdminNavComponent';
import AdminStats from './AdminStatsComponent';
import { useAuth0 } from '@auth0/auth0-react';

function QuizAdmin(){

    const deleteQuiz = async (event) => {
        const deletePromiseResponse = await fetch(process.env.REACT_APP_DATABASE_URL + '/quizzes', {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            },
            body: JSON.stringify({
                quizId: event.target.dataset.quizId
            })
        });
        const deleteResponse = await deletePromiseResponse.json();

        if(deleteResponse.success){
            dispatch(quizDeleted(deleteResponse.quiz_id));
            alert(deleteResponse.message);
        } else if (deleteResponse.message) {
            alert(deleteResponse.message);
        } else {
            alert("Issue deleting quiz entry: " + deleteResponse.description)
        }

    };

    const dispatch = useDispatch();

    const [accessToken, setAccessToken] = useState('emptyTokenInAdmin');
    const { getAccessTokenSilently } = useAuth0();

    useEffect(() => {
        const getAccessToken = async () => {
            try {
                const jwt = await getAccessTokenSilently()
                setAccessToken(jwt);
                dispatch(fetchQuizzes(jwt));
            } catch (error) {
                // token retrieval failed
            }
        };

        getAccessToken();
    }, [getAccessTokenSilently, dispatch]);

    const listQuizzes = useSelector(state => state.quizzes.quizzesArray);

    const quizzesListTable = listQuizzes.map((quiz) => {
        const imgIdList = quiz.images.join(', ');

        return(
            <tr key={quiz.id} className="border-b border-gray-200 hover:bg-gray-50">
                <td className="px-4 py-2 text-sm font-medium">{quiz.id}</td>
                <td className="px-4 py-2 text-sm">{quiz.count}</td>
                <td className="px-4 py-2 text-sm">{quiz.average_success_rate}</td>
                <td className="px-4 py-2 text-sm">{quiz.images.length}</td>
                <td className="px-4 py-2 text-sm align-middle">{imgIdList}</td>
                <td className="px-4 py-2">
                    <button
                        className="px-3 py-1 bg-red-600 text-white text-sm rounded hover:bg-red-700 transition-colors"
                        data-quiz-id={quiz.id}
                        onClick={deleteQuiz}>
                            Delete
                    </button>
                </td>
            </tr>
        )
    });

    const quizzesListCards = listQuizzes.map((quiz) => {
        const imgIdList = quiz.images.join(', ');

        return(
            <div className="border border-gray-200 rounded bg-white p-4 shadow-sm" key={quiz.id}>
                <h5 className="font-semibold text-lg mb-2">Quiz id: {quiz.id}</h5>
                <p className="text-sm text-gray-700">
                    <b>Number of times played:</b> {quiz.count}<br /><br />
                    <b>Average success rate:</b> {quiz.average_success_rate}<br /><br />
                    <b>Number of images:</b> {quiz.images.length}<br /><br />
                    <b>Image list:</b><br />{imgIdList}
                </p>
                <button
                    className="mt-2 px-3 py-1 bg-red-600 text-white text-sm rounded hover:bg-red-700 transition-colors"
                    data-quiz-id={quiz.id}
                    onClick={deleteQuiz}>
                        Delete
                </button>
            </div>
        )
    });

    return(
        <>
            <AdminNavMain />
            <div className="max-w-7xl mx-auto px-4 pt-16">
                <h1 className="text-2xl font-bold text-gray-800 my-4">Quiz Admin</h1>
            </div>
            <AdminStats />
            <div className="max-w-7xl mx-auto px-4">
                {/* Table view for md+ */}
                <div className="hidden md:block overflow-x-auto">
                    <table className="w-full text-left border-collapse">
                        <thead>
                            <tr className="bg-gray-100 border-b-2 border-gray-300">
                                <th className="px-4 py-2 text-sm font-semibold">Quiz id</th>
                                <th className="px-4 py-2 text-sm font-semibold">Number of times played</th>
                                <th className="px-4 py-2 text-sm font-semibold">Average success rate</th>
                                <th className="px-4 py-2 text-sm font-semibold">Number of images</th>
                                <th className="px-4 py-2 text-sm font-semibold">Image list</th>
                                <th className="px-4 py-2"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {quizzesListTable}
                        </tbody>
                    </table>
                </div>
                {/* Card view for mobile */}
                <div className="md:hidden grid grid-cols-1 sm:grid-cols-2 gap-4">
                    {quizzesListCards}
                </div>
            </div>
        </>
    )
}

export default QuizAdmin;
